import { Component, ChangeDetectionStrategy } from "@angular/core";
import { SvgIconComponent } from "angular-svg-icon";
import { FormPageComponent } from "../../common/form/form.component";

@Component({
  selector: 'signup-verified',
  templateUrl: './signup-verified.component.html',
  standalone: true,
  styleUrl: './signup-verified.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SvgIconComponent, FormPageComponent,],
})
export class SignUpVerifiedComponent {

  constructor() {
  }
}
